import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getRaceTypeFilterForStatsSlice = createSlice({
    name: 'RaceTypeFilterForStats',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchRaceTypeFilterForStats.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchRaceTypeFilterForStats.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchRaceTypeFilterForStats.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setRaceTypeFilterForStats, setStatus } = getRaceTypeFilterForStatsSlice.actions;
export default getRaceTypeFilterForStatsSlice.reducer;

export const fetchRaceTypeFilterForStats = createAsyncThunk('/RaceTypeFilterForStats/fetch', async ({ 
    StartDate,
    EndDate,
    Nationality,
    RaceCourse,
    GroundType,
    RaceKind,
    HorseKind,
    RaceType,
    TrackLength}) => {
    const res = await axios.get(`${getBaseUrl()}/RaceTypeFilterForStats?StartDate=${StartDate === undefined ? "" : StartDate}&EndDate=${EndDate === undefined ? "" : EndDate}&Nationality=${Nationality === undefined ? "" : Nationality}&RaceCourse=${RaceCourse === undefined ? "" : RaceCourse}&GroundType=${GroundType === undefined ? "" : GroundType}&RaceKind=${RaceKind === undefined ? "" : RaceKind}&HorseKind=${HorseKind === undefined ? "" : HorseKind }&RaceType=${RaceType=== undefined ? "" : RaceType}&TrackLength=${TrackLength === undefined ? "" : TrackLength}&size=40`);
    const RaceTypeFilterForStatsData = res.data;
    return RaceTypeFilterForStatsData.data;
})
